import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getFrontLogger } from 'utils/loggers/FrontLogger';

import type { LightweightEvent, NotificationEvent } from './model';

export function logIncomingLightweightEvent(event: NotificationEvent, source: string): void {
  const frontLogger = getFrontLogger();
  frontLogger.info(`received streamed message from ${source} {@Event}`, event);
}

export function withPollingSource(input$: Observable<LightweightEvent>): Observable<LightweightEvent> {
  return input$.pipe(map(eventWithPollingSource));
}

function eventWithPollingSource(input: LightweightEvent): LightweightEvent {
  return { ...input, source: 'POLLING' };
}

export function withSignalrSource(input$: Observable<LightweightEvent>): Observable<LightweightEvent> {
  return input$.pipe(map(eventWithSignalrSource));
}

function eventWithSignalrSource(input: LightweightEvent): LightweightEvent {
  return { ...input, source: 'SIGNALR' };
}
